import { Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule, MatButton } from "@angular/material/button";
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { DashboardService } from '../../services/shared/dashboard.service';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ModifiedChangesComponent } from '../../modified-changes/modified-changes.component';
import { MatDialog } from '@angular/material/dialog';
import { SearchService } from '../../services/shared/search.service';




@Component({
  selector: 'app-header',
  standalone: true,
  imports: [(MatCardModule), (MatIconModule), (FormsModule), (MatInputModule), (MatFormFieldModule), (MatButtonModule), (MatButton), (MatMenuModule), (CommonModule), (ReactiveFormsModule), 
    MatExpansionModule,
    MatButtonModule,
    MatIconModule,
    MatExpansionPanel],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  encapsulation: ViewEncapsulation.None
})

export class HeaderComponent {
 
  searchControl = ''
  searchValue: string = '';
  panelVisible = false
  searchTerm: string = '';
  currentChildPath = "";
  
  private searchSubject: Subject<string> = new Subject<string>();
  @Output() sideNavElementEmitter = new EventEmitter<ElementRef>();

  @ViewChild('sideNavOnHeader') sideNavElement!: ElementRef;
 
  filteredSuggestions: any = [];
  user_role: any;
  userid: any;
  usename: any;
  

  ngAfterViewInit() {
    this.sideNavElementEmitter.emit(this.sideNavElement);
  }

  results: string[] = ['Angular', 'React', 'Vue', 'Svelte', 'Ember']; // Sample data
  filteredResults: string[] = [...this.results];
  constructor(private DashboardService: DashboardService , private authService : AuthService , private router: Router, private elementRef: ElementRef, private route:ActivatedRoute, private dailog: MatDialog, private searchService: SearchService) {
    this.searchSubject.pipe(debounceTime(1000)) // Adjust debounce time as needed
      .subscribe(value => {
        this.searchTerm = value.trim();
        if(this.searchTerm && this.searchTerm.length >= 3) {
          this.DashboardService.getSuggetion(this.searchTerm).subscribe((res: any)=>{
            //  this.filteredSuggestions = res.data
            this.filteredSuggestions = Array.from(
              new Map(res.data.map((item: any) => [item.title, item])).values()
            )
          })
        }
        else{
          this.filteredSuggestions =[]
        }
       
      });
  }
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    const clickedElement = event.target as HTMLElement;
    if (this.panelVisible && (this.elementRef.nativeElement.contains(clickedElement) || !this.elementRef.nativeElement.contains(clickedElement))) {
      this.panelVisible = false; // Close the card if clicked outside
    }
  }
  @Input() isopenFlag: boolean = false;
  @Output() isOpened = new EventEmitter<boolean>();
  onOpenSideBar() {
    this.isopenFlag = !this.isopenFlag;
    this.isOpened.emit(this.isopenFlag);
  }
  async ngOnInit() {
    this.user_role = this.DashboardService.user_role
    this.userid = this.DashboardService.user_id;
    this.usename = this.DashboardService.username
  }
  ngOnChanges() {
    this.filterResults();
  }
  focusOut() {
    setTimeout(() => {
      this.filteredSuggestions =[]  
    }, 300);
  }
  filterResults() {
    if (this.searchValue) {
      this.filteredResults = this.results.filter(item =>
        item.toLowerCase().includes(this.searchValue.toLowerCase())
      );
    } else {
      this.filteredResults = [...this.results];
    }
  }
  // seachresult(suggestion: string, event: any, isDropdown: boolean) {
  //   let suggestion_val = suggestion.trim();
  //   if(isDropdown) {
  //     this.searchControl = suggestion_val;
  //   }
  //   if(suggestion_val.length > 0 || (suggestion.length == 0 && suggestion_val.length == 0 && event?.inputType == "deleteContentBackward")) {
  //     this.DashboardService.serachData(suggestion.trim())
  //     this.focusOut();
  //   }
  // }


  seachresult(suggestion: string, event: any, isDropdown: boolean, searchObj: any = {}) {
    let suggestion_val = suggestion.trim();
    if(isDropdown) {
      this.route.children.forEach((childRoute) => {
        childRoute.url.subscribe((segments) => {
          this.currentChildPath = segments.map((segment) => segment.path).join('/');
        });
      });
      if(this.currentChildPath != 'dashboard') {
        const dialogRef = this.dailog.open(ModifiedChangesComponent, {
          data: {
            mode: 'search'
          },
          height: '240px',
          width: '450px'
        });
    
        dialogRef.afterClosed().subscribe((result) => {
          if(result.goBack && result.mode == 'search') {
            this.router.navigateByUrl('/home/dashboard');
            setTimeout(() => {
              this.searchControl = suggestion_val;
            }, 1000)
          } else {
            this.searchControl = "";
          }
        });
      } else {
        this.searchControl = suggestion_val;
      }
      if(Object.keys(searchObj).length > 0) {
        // this.searchService.setSearchData({"isDropdownSearch": true, "id": searchObj?.category_id, "name": searchObj?.category_name})
        let catName = ""
        let catStatus = searchObj.status.toUpperCase();
        if(this.user_role == 'creator' && (catStatus == "DRAFT" || catStatus == "SUBMITTED" || catStatus == "REJECTED")) {
          catName = "My Prompts"
        } else if(this.user_role == 'creator' && catStatus == "PUBLISHED") {
          catName = "All Categories"
        } else if(this.user_role == 'curator' || this.user_role === 'admin' && (catStatus == "DRAFT" || catStatus == "REJECTED")) {
          catName = "My Prompts"
        } else if(this.user_role == 'curator' || this.user_role === 'admin' && (catStatus == "SUBMITTED" && searchObj.created_by == this.userid)) {
          catName = "My Prompts"
        } else if(this.user_role == 'curator' || this.user_role === 'admin' && (catStatus == "SUBMITTED" && searchObj.created_by != this.userid)) {
          catName = "Approval Pending"
        } else if(this.user_role == 'curator' || this.user_role === 'admin' && catStatus == "PUBLISHED") {
          catName = "All Categories"
        } else if(this.user_role == 'user') { 
          catName = "All Categories"
        }

        this.searchService.setSearchData({
          "searchDropdown": true, 
          id: searchObj.category_id, 
          // name: searchObj.category_name,
          name: catName,
          parent_category_id: null,
          subcategories: [],
          ...searchObj
        })
      }
      
    } else {
      if(suggestion_val.length > 0 || (suggestion.length == 0 && suggestion_val.length == 0 && event?.inputType == "deleteContentBackward")) {
        // this.DashboardService.serachData(suggestion.trim())
        this.DashboardService.serachData({searchText: suggestion.trim(), searched: true})
        this.focusOut();
      }
    }
  }
 

  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchSubject.next(input.value);
  }

  highlightText(text: string, search: string): string {
    if (!search) return text;
    const regex = new RegExp(`(${search})`, 'gi');
    return text.replace(regex, '<mark>$1</mark>');
  }
  togglePanel() {
    this.panelVisible = !this.panelVisible;
  }

  logout() {
    this.authService.logout();
    localStorage.removeItem('originalTranslationData');
    localStorage.removeItem('accessToken');
    localStorage.removeItem('user');
    localStorage.removeItem('user_id');
    localStorage.removeItem('user_name');
    localStorage.clear();
    this.router.navigate(['/login']);
  }
}
